import { render, staticRenderFns } from "./Categolies.vue?vue&type=template&id=631dd3a5&scoped=true&"
import script from "./Categolies.vue?vue&type=script&lang=js&"
export * from "./Categolies.vue?vue&type=script&lang=js&"
import style0 from "./Categolies.vue?vue&type=style&index=0&id=631dd3a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631dd3a5",
  null
  
)

export default component.exports